import React from 'react';
import './Hero.css';

const ArrowRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero">
      {/* Decorative background blobs */}
      <div className="hero__blob hero__blob--1" aria-hidden="true" />
      <div className="hero__blob hero__blob--2" aria-hidden="true" />

      <div className="container hero__content">
        <h1 className="hero__title">
          Welcome to Thar<br />Enterprises
        </h1>
        <p className="hero__subtitle">
          Your trusted partner for business registration and compliance services.
          We simplify the complex so you can focus on what matters — growing your business.
        </p>
        <div className="hero__actions">
          <button className="hero__btn hero__btn--primary" onClick={() => scrollTo('contact')}>
            Get Started <ArrowRightIcon />
          </button>
          <button className="hero__btn hero__btn--outline" onClick={() => scrollTo('about')}>
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
